import script from "./ConfigList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfigList.vue?vue&type=script&setup=true&lang=ts"

import "./ConfigList.vue?vue&type=style&index=0&id=d0590768&lang=css"

const __exports__ = script;

export default __exports__